import styled, { css } from 'styled-components';
import {
  Divider,
  Icon,
  isMobileStyleMixin,
  Text,
  TextButton,
} from '@amzn/storm-ui';
import { StyledComponentsPropWithTheme } from 'src/commons/components/ChromeApp/ChromeAppUtils';
import { PAGE_LAYOUT_TYPE } from 'src/app/slice';
import { gray900, inkwell } from 'src/colors';

export const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.concrete};
`;

export const HeaderWrapper = styled.div<{
  pageLayoutType: PAGE_LAYOUT_TYPE;
}>`
  ${(props) =>
    props.pageLayoutType === PAGE_LAYOUT_TYPE.FOCUS
      ? `width: 100%; left: 0;`
      : `min-height: 60px;`}
  box-sizing: border-box;
  align-items: center;
  background: ${({ theme, pageLayoutType }) =>
    theme.header.contextBar.pageLayoutType[pageLayoutType]?.background ||
    theme.header.contextBar.background};
  color: ${({ theme }) => theme.header.contextBar.foreground};
  ${isMobileStyleMixin(css`
    padding: 0;
    height: auto;
  `)};
  width: 100%;
`;

export const Topbar = styled.header`
  display: flex;
  align-items: center;
  ${isMobileStyleMixin(css`
    min-height: 60px;
  `)};
`;

export const TopbarSecondRow = styled.header`
  display: flex;
  align-items: center;
  margin-left: 21px;
`;

export const FocusModeUtilitiesIconButton = styled(TextButton)<{
  active: boolean;
  isNotificationButton?: boolean;
}>`
  width: 40px;
  height: 40px;
  border-radius: 5px;
  margin: 0 5px;
  color: ${gray900};
  position: ${({ isNotificationButton }) => isNotificationButton && 'relative;'}

  ${({ active }) =>
    active &&
    `
    color: ${inkwell};
    opacity: 1;
    background-color: rgba(35, 47, 63, 0.1);
  `}
  &:active {
    transform: scale(0.95);
    transition-duration: 0.1s;
  }

  &:hover {
    color: ${inkwell};
    opacity: 1;
    background-color: rgba(35, 47, 63, 0.05);
  }
`;

export const UtilitiesIconButton = styled(TextButton)<{
  active?: boolean;
  isNotificationButton?: boolean;
}>`
  width: 40px;
  height: 40px;
  border-radius: 5px;
  margin: 0 5px;
  color: ${({ theme }) => theme.header.utility.icon.foreground};
  position: ${({ isNotificationButton }) => isNotificationButton && 'relative;'}

  ${({ active, theme }) =>
    active &&
    `
    color: ${theme.header.utility.icon.foregroundActive};
    opacity: 1;
    background-color: ${theme.header.utility.icon.backgroundActive};
  `}
  &:active {
    transform: scale(0.95);
    transition-duration: 0.1s;
  }

  &:hover {
    color: ${({ theme }) => theme.header.utility.icon.foregroundHover};
    opacity: 1;
    background-color: ${({ theme }) =>
      theme.header.utility.icon.backgroundHover};
  }
`;

export const UtilitiesIcon = styled(Icon)`
  font-size: 20px;
`;

interface NameAndEmailTextProps {
  title: string;
}

export const NameAndEmailText = styled(Text)<NameAndEmailTextProps>`
  margin-bottom: 2px;
  word-wrap: break-word;
`;

export const UserDropdownSectionContainer = styled('div')`
  font-size: 13px;
  padding: ${(props: StyledComponentsPropWithTheme) =>
    props.theme.spacing.base};
  min-width: 224px;
  max-width: 50vw;
`;

export const UserDropdownSectionDivider = styled(Divider)`
  margin: 0;
`;

export const Switcher = styled.div`
  color: #6f7782;
  text-align: left;
`;

export const LanguageLabel = styled.span`
  font-size: 11px;
  color: #6f7782;
  line-height: 19px;
  margin: 0 0 14px 6px;
  text-align: left;
`;

interface PageHeaderWrapperProps {
  hideTopPadding?: boolean;
}

export const PageHeaderWrapper = styled.div<PageHeaderWrapperProps>`
  position: relative !important;
  padding: ${(props) => (props.hideTopPadding ? '0px' : '18px')} 26px 0 26px;
  width: 100%;
  height: auto;
  box-sizing: border-box;
  z-index: 1;
  margin: 0;
`;

export const HeaderLinkWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  height: 40px;
  margin: 0 5px;
  font-size: 13px;

  & > a {
    color: white;
  }

  & > a:hover {
    color: white;
    text-decoration: underline;
  }
`;
